import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpClient } from "../HttpClient";


export const getAssetDisposalLogs = createAsyncThunk("getAssetDisposalLogs", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/asset-disposal-logs${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const result = response.Result
        const StatusCode = getAllData.status;

        console.log("success in asset data", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);

export const getDisposalDOA = createAsyncThunk("getDisposalDOA", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/asset-disposal-doa`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const result = response.Result
        const StatusCode = getAllData.status;

        console.log("success in asset data", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);


export const postDisposalReq = createAsyncThunk("postDisposalReq", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/asset_management/asset-disposal-logs`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const postDisposalApproval = createAsyncThunk("postDisposalApproval", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/asset_management/asset-disposal-approvals`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const AssetDisposaluploadFile = createAsyncThunk("AssetDisposaluploadFile", async (data) => {
    try {
        const postAllData = await httpClient.post(`/internal-db/internal/db/asset_management/asset-disposal-uploadfile`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        // const result = response.Result;
        console.log("success in PV Logs", response);
        return {
            StatusCode,
            response
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getUsersforDOA = createAsyncThunk("getUsersforDOA", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/usermodels/users/details${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const result = response.Result
        const StatusCode = getAllData.status;

        console.log("success in asset data", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);



export const PliPostLog = createAsyncThunk("PliPostLog", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/asset_management/asset-pli-logs`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    }
    //  catch (error) {
    //     if (error.response && error.response.status === 400) {
    //         const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
    //         throw new Error(backendMessage);
    //     } else {
    //         throw new Error("Something went wrong, please try again later.");
    //     }
    // }
    catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message;

            // Check if 'Message' is an object (e.g., validation errors)
            if (typeof backendMessage === 'object' && backendMessage !== null) {
                const validationErrors = Object.entries(backendMessage)
                    .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
                    .join("; ");

                throw new Error(`Validation failed: ${validationErrors}`);
            } else {
                // Handle the case where 'Message' is a string or undefined
                const message = backendMessage || "An error occurred while processing the request";
                throw new Error(message);
            }
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const PLIUploadFile = createAsyncThunk("PLIUploadFile", async (data) => {
    try {
        const postAllData = await httpClient.post(`/internal-db/internal/db/asset_management/asset-pli-file`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        // const result = response.Result;
        console.log("success in PV Logs", response);
        return {
            StatusCode,
            response
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getAssetPLILogs = createAsyncThunk("getAssetPLILogs", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/asset-pli-logs${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const result = response.Result
        const StatusCode = getAllData.status;

        console.log("success in asset data", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);




export const assetDeclarationFileUpload = createAsyncThunk("assetDeclarationFileUpload", async (data) => {
    try {
        const postAllData = await httpClient.post(`/internal-db/internal/db/asset_management/asset-pli-declaration`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const response = postAllData.data;
        const StatusCode = postAllData.status;
        // const result = response.Result;
        console.log("success in PV Logs", response);
        return {
            StatusCode,
            response
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getAssetDeclarationHistory = createAsyncThunk("assetDeclarationHistory", async (vendor_no) => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/asset-pli-declaration?vendor_no=${vendor_no}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const result = response.Result
        const StatusCode = getAllData.status;

        console.log("success in asset data", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);

export const getAssetDeclarationFile = createAsyncThunk("getAssetDeclarationFile", async (id) => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/asset-pli-declaration?asset_declrtn_id=${id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        // const result = response.Result
        const StatusCode = getAllData.status;

        console.log("success in asset data", response);
        return {
            response,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);


const AssetDisposalSlice = createSlice({
    name: "AssetDisposalSlice",
    initialState: {
        loading: false,
        error: null,
        response: null,
        reason: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAssetDisposalLogs.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getAssetDisposalLogs.fulfilled, (state, action) => {
                state.loading = false;
                state.response = action.payload.result;
            })
            .addCase(getAssetDisposalLogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(getDisposalDOA.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getDisposalDOA.fulfilled, (state, action) => {
                state.loading = false;
                state.reason = action.payload.result;
            })
            .addCase(getDisposalDOA.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
})


export default AssetDisposalSlice.reducer;